<template>
  <login-layout :title="title">
    <div v-if="!userEnabled">
      {{ $t('Utente non abilitato alla conferma dei "Termini e condizioni"') }}.
      <i18n-t
        keypath="Effettuare il {0} e accedere nuovamente con utente abilitato (con permessi di livello Admin o Amministrativi)">
        <a href="/api/auth/logout">{{ $t('Logout') }}</a>
      </i18n-t>
    </div>

    <x-form v-else-if="contractState.state === 'success'" @submit="accept">
      <iframe class="terms" referrerpolicy="no-referrer" sandbox="" :srcdoc="contract.testo" />

      <pf-form-group>
        <pf-checkbox name="accept" required :label="$t('Ho letto e accettato i termini e le condizioni')" />
      </pf-form-group>
    </x-form>

    <pf-empty-state v-else>
      <pf-empty-state-header :title="$t('Caricamento termini e condizioni')" heading-level="h4" />
    </pf-empty-state>

    <template #forgot-credentials>
      <pf-button variant="link" href="/api/auth/logout">{{ $t('Logout') }}</pf-button>
    </template>
  </login-layout>
</template>

<style scoped>
.terms {
  width: 100%;
  max-width: 800px;
  border: var(--pf-v6-global--BorderWidth--sm) solid var(--pf-v6-global--BorderColor--300);
  height: 300px;
  overflow: scroll;
  margin-bottom: 10px;
}
.btn-logout {
  margin-top: 40px;
}
</style>

<script lang="ts" setup>
import LoginLayout from '../../components/login-layout.vue';
import { ContractResource, CompanyResource } from '@/resources';
import { asyncComputed } from '@common/asyncComputed';
import { useLoginStore } from '../../store/login';
import { $t as _t } from '@/i18n';
import { loginDestination } from '../../utils';
import { useRouter, useRoute } from 'vue-router';
import { onBeforeMount, watch, computed } from 'vue';
import { AsyncComputedState } from '@common/asyncComputed';
import { useAlertStore } from '@/store/alerts';

const login = useLoginStore();
const router = useRouter();
const route = useRoute();

onBeforeMount(() => {
  if (login.contratto_cliente !== false) {
    router.push(loginDestination(route.query));
  }
});

const title = _t('Per poter accedere è necessario accettare i nostri "Termini e condizioni"');
const userEnabled = computed(() => login.grants.owner || login.grants.admin || login.grants.billing);

const { result: contract, state: contractState } = asyncComputed(async() => {
  const contract = await new ContractResource().get('cliente');
  contract.testo = `<html><head><style>
body {
  zoom: 80%;
  margin: 10px;
}

p:first-child {
  margin-top: 0;
}

p:last-child {
  margin-bottom: 0;
}
</style></head>
<body>${contract.testo}</body></html>`;
  return contract;
});

async function accept() {
  if (login.id_azienda) {
    await new CompanyResource().put(login.id_azienda, {
      contratto_cliente: true,
    });

    const alertStore = useAlertStore();
    alertStore.add({ title: _t('Termini e condizioni accettati'), type: 'success', toast: true });
    await login.refresh();
  }

  router.push(loginDestination(route.query));
}

watch(() => contractState.state, (value) => {
  document.body.dataset.ouiaPageSafe = value === AsyncComputedState.Updating ? 'false' : 'true';
});
</script>
